<template>
  <div class="decorate">
    <div
      class="cover-wrapper"
      v-for="(cover, coverIndex) of coverDataList"
      :key="coverIndex"
    >
      <div :class="['cover-pack']" @mousedown.stop>
        <cover
          :id="'cover' + coverIndex"
          :bgConfig="cover.bgParameter"
          :elementImg="cover.elementImg"
          :size="cover.size"
          :elConfig="cover.elementInfo"
          :textConfig="cover.textInfo"
          :fontStyles="cover.fontStyles"
        />
        <template v-if="coverDataList.length > 1">
          <span class="mask"></span>
          <span class="delete" @click="deleteCover(coverIndex)">删除</span>
        </template>
      </div>
      <div class="input-area">
        <CoverInput
          v-for="(fontStyle, index) in cover.fontStyles"
          :key="'line' + index"
          :showLabelName="false"
          :showLabelStyle="false"
          :themeColor="cover.bgParameter.tagBgColor"
          :fontStyle="fontStyle"
          @mainInput="handleMainInput"
        />
      </div>
    </div>
    <div class="copy-tool">
      复制<span class="input-square"
        ><input type="text" v-model="designNum" v-force-input-number /><i
          class="increase iconfont icon-fangxiang"
          @click="designNum++"
        ></i
        ><i
          class="reduce iconfont icon-fangxiang"
          @click="designNum > 0 ? designNum-- : 0"
        ></i></span
      >个<span class="btn" @click="onCopy">确定</span>
    </div>
    <div class="footer-panel">
      <span class="panel-btn" @click="preStep"
        >{{ schemeId ? "返回" : "上一步" }}
      </span>
      <div class="panel-right">
        <span
          v-if="schemeId"
          v-loading="isSaving"
          element-loading-spinner="el-icon-loading"
          :class="['live-btn', !legalInput && 'disable']"
          @click="onSave(schemeId)"
        >
          覆盖原图
        </span>
        <router-link
          v-if="schemeId"
          class="live-btn"
          :to="{ name: 'coverBuild', query: { schemeId } }"
        >
          修改样式
        </router-link>
        <span
          v-loading="isSaving"
          element-loading-spinner="el-icon-loading"
          :class="['live-btn', !legalInput && 'disable']"
          @click="onSave()"
        >
          {{ schemeId ? "另存" : "暂存设计" }}
        </span>
        <span
          :class="['panel-btn', !legalInput && 'disable']"
          element-loading-spinner="el-icon-loading"
          @click="downLoad(schemeId)"
          v-loading="isDownLoading"
        >
          {{ isDownLoading ? "下载中" : `暂存并下载(${coverDataList.length})` }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/assets/scripts/api";
import { getLabelStyleMenu } from "@/assets/scripts/common.js";
import { downloadBase64 } from "@/assets/scripts/utils.js";
import cover from "@/pages/cover/components/cover.vue";
import http from "@/plugins/http";
import { mapMutations, mapState } from "vuex";
import CoverInput from "./components/coverInput.vue";
import {
  checkCoverText,
  saveCoverToBase,
  setTextStyleMap,
} from "./js/cover-feature";
export default {
  name: "decorate",
  data() {
    return {
      // 是否正在下载
      isDownLoading: false,
      // 正在保存
      isSaving: false,
      // 设计id
      schemeId: "",
      // 某个封面合法输入
      legalInput: true,
      // 复制的数量
      designNum: 1,
    };
  },
  components: {
    cover,
    CoverInput,
  },
  computed: {
    ...mapState("cover", ["coverData", "coverDataList"]),
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      vm.schemeId = to.query.schemeId;
      // 获取用户设计详情
      vm.schemeId &&
        from.name === "coverDesigns" &&
        vm.getDesignDetail(vm.schemeId);
    });
  },
  watch: {
    // 监听封面列表的文字输入变化
    coverDataList: {
      handler(list) {
        for (let i = 0; i < list.length; i++) {
          const { fontStyles } = list[i];
          this.legalInput = checkCoverText(fontStyles);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations("cover", [
      "updateCoverData",
      "updateCoverDataList",
      "deleteCoverData",
    ]),
    // 获取用户设计详情
    async getDesignDetail(schemeId) {
      let { data } = await http.get(
        `${api.scheme}?schemeId=${schemeId}&platformType=2`
      );
      if (data.list.length) {
        data.list.forEach((element) => {
          // 获取label样式表
          const labelStyleMenu = getLabelStyleMenu(
            element.bgParameter.tagBgColor
          );
          const { fontStyles } = element;
          fontStyles.forEach((item, index) => {
            // 将label样式追加到字体样式中
            const lableStyleMap =
              labelStyleMenu[item.labelStyle.slice(-1)] || {};
            lableStyleMap.style && Object.assign(item, lableStyleMap.style);
            setTextStyleMap(item, index);
          });
        });
        this.updateCoverDataList({
          list: data.list,
          isClearCoverDataList: true,
        });
        this.updateCoverData(data.list[0]);
      }
    },
    // 处理主标题换行
    handleMainInput(fontStyle, text) {
      this.updateCoverDataList({
        data: fontStyle,
        options: { text },
      });
    },
    // 复制封面
    onCopy() {
      this.updateCoverDataList({
        num: this.designNum,
      });
    },
    // 删除封面
    deleteCover(index) {
      this.deleteCoverData(index);
    },
    // 下载并保存
    async downLoad(schemeId) {
      if (this.isDownLoading) return;
      this.isDownLoading = true;
      // 提交用户设计
      saveCoverToBase(this.coverDataList, schemeId);
      const downData = await downloadBase64(this.coverDataList, "cover");
      if (downData.code === 10000) {
        this.$message.success("下载成功");
      }
      this.$router.push("/");
      this.isDownLoading = false;
    },
    // 保存
    async onSave(schemeId = "") {
      if (this.isSaving) return;
      this.isSaving = true;
      const result = await saveCoverToBase(this.coverDataList, schemeId);
      const { data, message, code } = result;
      if (code === 10000 && data) {
        this.$message({
          message: "成功保存到我的设计",
          type: "success",
          onClose: () => {
            this.isSaving = false;
            this.$router.push("/cover/list");
          },
        });
      } else {
        message && this.$message.error(message);
      }
    },
    preStep() {
      this.$router.replace("/cover/build");
    },
  },
};
</script>
<style lang="scss" scoped>
.decorate {
  height: calc(100% - 60px);
  position: relative;
  width: 100%;
  padding: 45px 0 180px;
  overflow: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  .cover-wrapper {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    min-height: 105px;
    width: 780px;
    margin: 35px auto 0 10%;
    .cover-pack {
      position: relative;
      cursor: pointer;
      .mask {
        display: none;
        position: absolute;
        content: "";
        left: 0%;
        top: 0%;
        bottom: 0%;
        right: 0%;
        background: rgba($color: #000000, $alpha: 0.8);
        z-index: 99;
      }
      .delete {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: none;
        width: 68px;
        border-radius: 23px;
        border: 1px solid #ffffff;
        color: #fff;
        text-align: center;
        line-height: 28px;
        font-weight: 600;
        z-index: 100;
      }
      &:hover {
        .delete {
          display: block;
        }
        .mask {
          display: block;
        }
      }
    }
    .input-area {
      width: 540px;
      margin-left: 10px;
    }
  }
  .copy-tool {
    width: 200px;
    height: 46px;
    line-height: 30px;
    padding: 8px 12px;
    margin: 35px auto 0 10%;
    background: #ffffff;
    border-radius: 8px;
    .input-square {
      position: relative;
      display: inline-block;
      vertical-align: top;
      width: 64px;
      height: 30px;
      margin: 0 4px;
      border-radius: 3px;
      overflow: hidden;
      border: 1px solid #cacaca;
      input {
        width: 34px;
        height: 100%;
        vertical-align: top;
        border: 0px;
        outline: 0px;
        font-size: 14px;
        text-align: center;
      }
      .increase,
      .reduce {
        position: absolute;
        right: 0;
        width: 30px;
        height: 14px;
        line-height: 14px;
        background: #eceef5;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
        &:hover {
          background: #d2d4d9;
        }
      }
      .increase {
        top: 0;
        &:before {
          display: inline-block;
          transform: rotate(-90deg);
        }
      }
      .reduce {
        bottom: 0;
        &:before {
          display: inline-block;
          transform: rotate(90deg);
        }
      }
    }
    .btn {
      display: inline-block;
      vertical-align: top;
      width: 44px;
      height: 30px;
      background: #3f69f9;
      border-radius: 4px;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      color: #fff;
      &:hover {
        background: #2753ec;
      }
    }
  }
  .icon-jingshi {
    margin-right: 5px;
    color: #ff6a00;
    font-size: 23px;
  }
  .download_wrap {
    overflow: hidden;
    z-index: -1;
    width: 0;
    height: 0;
  }
}
</style>
